import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../common/enums';
import { selectUpdatedPermitData } from '../../store/slices/update/updateSelectors';
import { updatePermitData } from '../../store/slices/update/updateSlice';
import { ApplicationData } from 'src/types/flow';
import { useAppDispatch } from 'src/store/store';
import { ContactsPage } from 'src/components/pages/ContactsPage';

const UpdateContacts = () => {
  const dispatch = useAppDispatch();
  const data = useSelector(selectUpdatedPermitData) as ApplicationData;

  const updateApplicationData = (data: ApplicationData) => {
    dispatch(updatePermitData(data));
  };

  return (
    <ContactsPage
      data={data}
      flow={FLOWS_ENUM.UPDATE_CERTIFICATE}
      updateApplicationData={updateApplicationData}
    />
  );
};

export default UpdateContacts;
